import { Button, Divider, Grid, TextField, Typography } from '@mui/material'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import PrimeTable from '../../../components/PrimeTable'
import { useState, useContext, useCallback, useEffect } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setSuccess } from '../../../components/alerts'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { PropostaContext } from './index'
import dayjs from 'dayjs'

const FormaPagamento = () => {
  const { dadosEdicao, dispatch } = useContext(PropostaContext)
  const [listaForma, setListaForma] = useState([])

  const salvar = async (values, close) => {
    const payload = {
      idAtendimento: dadosEdicao.idAtendimento,
      idFormaPagamento: values?.acFormaPagamento?.[0]?.[0],
      vlTotal: values?.vlTotal,
      qtParcelas: values?.qtParcelas || null,
    }

    const resp = await metodoPrograma('addFormaPagamento', payload)
    if (resp.status) {
      setSuccess('Forma de Pagamento salva com sucesso!')
      await lista()
      close()
    }
  }

  const setVlCalcao = useCallback(
    (value) =>
      dispatch({
        type: 'updateCaucao',
        value,
        valuesOld: dadosEdicao,
      }),
    [dadosEdicao, dispatch],
  )

  const editar = async (linha, close) => {
    const payload = {
      idAtendimento: dadosEdicao.idAtendimento,
      sqPagamento: linha?.[0],
      idFormaPagamento: linha?.[1]?.[0]?.[0],
      vlTotal: Number(linha?.[2] || 0),
      qtParcelas: linha?.[3] || null,
    }
    const resp = await metodoPrograma('addFormaPagamento', payload)

    if (resp.status) {
      setSuccess('Forma de Pagamento alterada com sucesso!')
      await lista()
      close()
    }
  }

  const lista = useCallback(async () => {
    if (!dadosEdicao.idAtendimento) return
    const { lista, status } = await metodoPrograma('listaFormaPagamento', {
      idAtendimento: dadosEdicao.idAtendimento,
    })

    if (status) {
      setVlCalcao(
        lista?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.vlPago,
          0,
        ),
      )

      const normalizada = (lista || []).map((item) => [
        item?.sqPagamento,
        item?.formaPagamento,
        item?.vlPago,
        item?.qtParcelas,
        item?.dtExclusao,
        item?.dtPagamento,
      ])
      setListaForma(normalizada)
    }
  }, [dadosEdicao.idAtendimento, setVlCalcao])

  useEffect(() => {
    lista()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const exclui = async (linha) => {
    const payload = {
      idAtendimento: dadosEdicao.idAtendimento,
      idFormaPagamento: linha?.[1]?.[0]?.[0],
      sqPagamento: linha?.[0],
    }

    const resp = await metodoPrograma('excluiFromaPagamento', payload)
    if (resp.status) {
      setSuccess('Forma de Pagamento excluída com sucesso!')
      await lista()
    }
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Typography variant="h5">Pagamentos</Typography>
          <Divider />
        </Grid>
        <Grid container spacing={2} style={{ padding: 20 }} item xs={12}>
          <Grid item container spacing={2}>
            {dadosEdicao.idAtendimento && (
              <Grid item xs={12}>
                <PrimeTable
                  dadosTable={listaForma}
                  disablePagination
                  autocompleteEditableIndex={[0]}
                  head={['Item', 'Data Pagamento', 'Valor', '', '']}
                  line={(item) => [
                    item?.[3]
                      ? `${item?.[1]?.[1]} x${item?.[3]}`
                      : item?.[1]?.[1],
                    item?.[5]
                      ? dayjs(item?.[5]).format('DD/MM/YYYY HH:mm')
                      : '',
                    item?.[2],
                    '',
                    item?.[4],
                  ]}
                  collumnsDateHour={[1]}
                  collumnsCurrency={[2]}
                  rows={100000}
                  editButton={dadosEdicao.tpSituacao === '0'}
                  addButton={dadosEdicao.tpSituacao === '0'}
                  onDelete={
                    dadosEdicao.tpSituacao === '0'
                      ? { index: 3, action: exclui }
                      : undefined
                  }
                  refresh={listaForma}
                  fastAddComponent={({ values, edit, close }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <AutoComplete
                          InputLabelProps={{ shrink: true }}
                          label="Forma de Pagamento"
                          metodo="buscaFormaPagamento"
                          getOptionLabel={(v) => v?.[1] || ''}
                          value={values?.acFormaPagamento ?? []}
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          onChange={async (_, val) => {
                            await edit({
                              value: val,
                              field: 'acFormaPagamento',
                            })
                            await edit({
                              value: val?.[2] || 0,
                              field: 'vlTotal',
                            })
                          }}
                          textFieldProps={{
                            helperText: !values?.acFormaPagamento
                              ? 'Campo Obrigatório!'
                              : '',
                            error: !values?.acFormaPagamento,
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={values?.acFormaPagamento?.[3] ? 3 : 6}
                      >
                        <CurrencyField
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          name="vlTotal"
                          label="Valor"
                          size="small"
                          value={values?.vlTotal}
                          onChange={(v) => edit({ value: v, field: 'vlTotal' })}
                          helperText={
                            !values?.vlTotal ? 'Campo Obrigatório!' : ''
                          }
                          error={!values?.vlTotal}
                        />
                      </Grid>
                      {values?.acFormaPagamento?.[3] && (
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            margin="dense"
                            label="Parcelas"
                            value={values?.qtParcelas}
                            onChange={async (e) => {
                              const val = e?.target?.value

                              await edit({
                                value: val,
                                field: 'qtParcelas',
                              })
                            }}
                          />
                        </Grid>
                      )}

                      <Grid
                        item
                        container
                        xs={12}
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={close}
                            fullWidth
                            variant="contained"
                            color="inherit"
                            style={{ margin: '5px' }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={() =>
                              !!values?.vlTotal &&
                              !!values?.acFormaPagamento &&
                              salvar(values, close)
                            }
                            variant="contained"
                            fullWidth
                            color="primary"
                            style={{ margin: '5px' }}
                          >
                            Salvar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  fastEditComponent={({ linha, close, edit }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <AutoComplete
                          InputLabelProps={{ shrink: true }}
                          metodo="buscaFormaPagamento"
                          label="Forma de Pagamento"
                          getOptionLabel={(v) => v?.[1] || ''}
                          value={linha?.[1]}
                          name="acFormaPagamento"
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          onChange={async (_, val) => {
                            await edit({ value: val, index: 1 })
                            await edit({ value: val?.[2] || 0, index: 2 })
                          }}
                          textFieldProps={{
                            helperText: !linha?.[1] ? 'Campo Obrigatório!' : '',
                            error: !linha?.[1],
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={linha?.[1]?.[3] ? 3 : 6}>
                        <CurrencyField
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          label="Valor"
                          size="small"
                          value={linha?.[2]}
                          onChange={(v) => edit({ value: v, index: 2 })}
                          helperText={!linha?.[2] ? 'Campo Obrigatório!' : ''}
                          error={!linha?.[2]}
                        />
                      </Grid>
                      {linha?.[1]?.[3] && (
                        <Grid item xs={3}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            margin="dense"
                            label="Parcelas"
                            value={linha?.[3] || ''}
                            onChange={async (e) => {
                              await edit({
                                value: e?.target?.value,
                                index: 3,
                              })
                            }}
                          />
                        </Grid>
                      )}
                      <Grid
                        item
                        container
                        xs={12}
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={close}
                            fullWidth
                            variant="contained"
                            color="inherit"
                            style={{ margin: '5px' }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={() =>
                              !!linha?.[1] &&
                              !!linha?.[2] &&
                              editar(linha, close)
                            }
                            variant="contained"
                            fullWidth
                            color="primary"
                            style={{ margin: '5px' }}
                          >
                            Editar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
export default FormaPagamento
